<div class="search-page-shell">

  <!-- ============================================================
       SEARCH / FILTERS
  ============================================================ -->

  <div class="search-toolbar" [class.filters-open]="filterDialogOpen" *ngIf="!isMobileDetailOpen">

    <div class="search-toolbar-inner">

      <app-search-filters
        [filterData]="filterObject"
        [ciPaidAccess]="hasPaidCiAccess"
        (filterOpenChange)="filterDialogOpen = $event"
        (filtersApplied)="hasActiveFilters = $event">
      </app-search-filters>

    </div>

  </div>


  <!-- ============================================================
       MAIN PROPERTY CONTENT
  ============================================================ -->

  <div class="search-content">

    <!-- ==========================================================
         LEFT: PROPERTY LIST
    =========================================================== -->

    <section
      #asideWrapper
      *ngIf="!isMobileView() || !isMobile"
      class="property-list-panel"
    >

      <app-search-aside
        class="property-list-content"

        [activeTab]="currentTab"

        (tabChanged)="currentTab = $event"

        [propertyList]="propertyList()"

        [selectedItem]="selectedItem()"

        (selectedItemChange)="selectedProperty($event, true)"

        [filteredCount]="filteredCount"

        [hasActiveFilters]="hasActiveFilters">
      </app-search-aside>

    </section>


    <!-- ==========================================================
         RIGHT: PROPERTY DETAIL
    =========================================================== -->

    <section
      *ngIf="!isMobile"
      class="view-area-panel"
    >

      @if(hasPaidPropertyAccess) {

        <app-view-area
          [selectedItem]="selectedItem()"
          [(activeTab)]="propertyDetailTab"
          (lightboxOpen)="openLightbox($event)"
          class="view-area-content">
        </app-view-area>

      } @else {

        <app-basicuserview
          [selectedItem]="selectedItem()"
          [(activeTab)]="propertyDetailTab"
          (lightboxOpen)="openLightbox($event)"
          class="view-area-content">
        </app-basicuserview>

      }

    </section>


    <!-- ==========================================================
         MOBILE DETAIL
    =========================================================== -->

    @if(hasPaidPropertyAccess) {

      <app-mobile-view
        *ngIf="isMobileView()"
        [selectedItem]="selectedItem()"
        [(activeTab)]="propertyDetailTab"
        (onClose)="closeMobileView()"
        (lightboxOpen)="openLightbox($event)"
        class="mobile-detail">
      </app-mobile-view>

    } @else {

      <app-basicmobileview
        *ngIf="isMobileView()"
        [selectedItem]="selectedItem()"
        [(activeTab)]="propertyDetailTab"
        (onClose)="closeMobileView()"
        (lightboxOpen)="openLightbox($event)"
        class="mobile-detail">
      </app-basicmobileview>

    }

  </div>

</div>





<!-- ================================================================
     GLOBAL LIGHTBOX
================================================================ -->

<div
  *ngIf="isLightboxOpen"
  (click)="handleLightboxBackdropClick()"
  (touchstart)="onLightboxTouchStart($event)"
  (touchmove)="onLightboxTouchMove($event)"
  (touchend)="onLightboxTouchEnd()"
  style="
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100dvh;
    z-index: 2147483647;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: pan-y;
  "
>

  <!-- CLOSE BUTTON -->

  <button
    type="button"
    aria-label="Close"
    (click)="closeLightbox(); $event.stopPropagation()"
    style="
      position: fixed;
      top: 24px;
      right: 24px;
      z-index: 2147483647;
      width: 52px;
      height: 52px;
      border: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
      font-size: 32px;
      line-height: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    ×
  </button>


  <!-- PREVIOUS -->

  <button
    type="button"
    aria-label="Previous image"
    (click)="previousLightbox(); $event.stopPropagation()"
    style="
      position: fixed;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2147483647;
      width: 52px;
      height: 52px;
      border: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
      font-size: 42px;
      line-height: 1;
      cursor: pointer;
    "
  >
    ‹
  </button>


  <!-- NEXT -->

  <button
    type="button"
    aria-label="Next image"
    (click)="nextLightbox(); $event.stopPropagation()"
    style="
      position: fixed;
      right: 24px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2147483647;
      width: 52px;
      height: 52px;
      border: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
      font-size: 42px;
      line-height: 1;
      cursor: pointer;
    "
  >
    ›
  </button>


  <!-- MEDIA -->

  <div
    (click)="$event.stopPropagation()"
    style="
      width: 80vw;
      height: 80vh;
      display: flex;
      align-items: center;
      justify-content: center;
      touch-action: pan-y;
    "
  >

    <ng-container
      *ngIf="selectedItemGalleryImages[activeLightboxIndex] as item"
    >

      <img
        *ngIf="item.type === 'image'"
        [src]="item.src"
        alt="Property image"
        style="
          max-width: 90%;
          max-height: 90%;
          width: auto;
          height: auto;
          object-fit: contain;
        "
      />

      <video
        *ngIf="item.type === 'video'"
        [src]="item.src"
        controls
        autoplay
        playsinline
        style="
          max-width: 90%;
          max-height: 90%;
        "
      ></video>

    </ng-container>

  </div>

</div>
